import store from '../store'

import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/projects',
    name: 'projects.index',
    component: () => import(/* webpackChunkName: "project_index" */ '../views/project/Index.vue'),
    beforeEnter: (to, from, next) => {
      store.commit('setIsSidebarMinimized', false)
      store.dispatch('project/fetchAllProjects')
      next()
    },
    meta: {
      auth: true,
      layout: AppLayout,
      title: 'โครงการทั้งหมด'
    }
  },
  {
    path: '/projects/:id',
    component: () => import(/* webpackChunkName: "project_show_layout" */ '../views/layouts/ProjectShowLayout'),
    beforeEnter: (to, from, next) => {
      store.commit('setIsSidebarMinimized', true)
      store.dispatch('project/fetchProject', to.params.id)
      next()
    },
    meta: {
      auth: true
    },
    children: [
      {
        path: 'proposal/basic',
        name: 'projects.show.proposal.basic',
        component: () => import(/* webpackChunkName: "project_proposal_basic" */ '../views/project/show/proposal/Basic.vue'),
        meta: {
          title: 'ข้อมูลพื้นฐานโครงการ',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/basic/edit',
        name: 'projects.show.proposal.basic.edit',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/BasicEdit.vue'),
        meta: {
          title: 'ข้อมูลพื้นฐานโครงการ',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/planning',
        name: 'projects.show.proposal.planning',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/Planning.vue'),
        meta: {
          title: 'แผนการดำเนินงาน',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/planning/edit',
        name: 'projects.show.proposal.planning.edit',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/PlanningEdit.vue'),
        meta: {
          title: 'แผนการดำเนินงาน',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/budget',
        name: 'projects.show.proposal.budget',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/Budget.vue'),
        meta: {
          title: 'งบประมาณ',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/budget/edit',
        name: 'projects.show.proposal.budget.edit',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/BudgetEdit.vue'),
        meta: {
          title: 'งบประมาณ',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/outcome',
        name: 'projects.show.proposal.outcome',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/Outcome.vue'),
        meta: {
          title: 'เป้าหมาย/ตัวชี้วัดความสำเร็จ',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/outcome/edit',
        name: 'projects.show.proposal.outcome.edit',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/OutcomeEdit.vue'),
        meta: {
          title: 'เป้าหมาย/ตัวชี้วัดความสำเร็จ',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/other',
        name: 'projects.show.proposal.other',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/Other.vue'),
        meta: {
          title: 'ข้อมูลเพิ่มเติม',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/documents',
        name: 'projects.show.proposal.documents',
        component: () => import(/* webpackChunkName: "project_proposal_documents" */ '../views/project/show/proposal/Documents.vue'),
        meta: {
          title: 'เอกสารเพิ่มเติม',
          layout: AppLayout
        }
      },
      {
        path: 'proposal/other/edit',
        name: 'projects.show.proposal.other.edit',
        component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/OtherEdit.vue'),
        meta: {
          title: 'ข้อมูลเพิ่มเติม',
          layout: AppLayout
        }
      },

      {
        path: 'proposal/edit',
        name: 'projects.show.proposal.edit',
        component: () => import(/* webpackChunkName: "project_proposal_edit" */ '../views/project/Edit.vue'),
        meta: {
          title: 'แก้ไขแบบขออนุมัติงบประมาณและจัดโครงการ',
          layout: AppLayout
        }
      },
      {
        path: 'evaluation',
        name: 'projects.show.evaluation.index',
        component: () => import(/* webpackChunkName: "project_evaluation_index" */ '../views/project/show/evaluation/Index.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประเมินผลโครงการ'
        }
      },
      {
        path: 'evaluation/participants',
        name: 'projects.show.evaluation.participant',
        component: () => import(/* webpackChunkName: "project_evaluation_participant" */ '../views/project/show/evaluation/Participant.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประเมินผลโครงการ'
        }
      },
      {
        path: 'evaluation/participantList',
        name: 'projects.show.evaluation.participantList',
        component: () => import(/* webpackChunkName: "project_evaluation_participant" */ '../views/project/show/evaluation/ParticipantList.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประเมินผลโครงการ'
        }
      },
      {
        path: 'evaluation/expenses',
        name: 'projects.show.evaluation.expenses',
        component: () => import(/* webpackChunkName: "project_evaluation_expenses" */ '../views/project/show/evaluation/Expense.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประเมินผลโครงการ'
        }
      },
      {
        path: 'evaluation/gallery',
        name: 'projects.show.evaluation.gallery',
        component: () => import(/* webpackChunkName: "project_evaluation_gallery" */ '../views/project/show/evaluation/Gallery.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประเมินผลโครงการ'
        }
      },
      {
        path: 'evaluation/satisfactionQuestionnaire',
        name: 'projects.show.evaluation.satisfactionQuestionnaire',
        component: () => import('../views/project/show/evaluation/SatisfactionQuestionnaire.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประเมินผลโครงการ'
        }
      },
      {
        path: 'history',
        name: 'projects.show.history',
        component: () => import(/* webpackChunkName: "project_history" */ '../views/project/show/History.vue'),
        meta: {
          layout: AppLayout,
          title: 'ประวัติการพิจารณาโครงการ'
        }
      },
      {
        path: 'change-requests',
        name: 'projects.show.change-requests.index',
        component: () => import(/* webpackChunkName: "project_change_requests" */ '../views/project/change-requests/Index.vue'),
        meta: {
          layout: AppLayout,
          title: 'รายการขอแก้ไข'
        }
      }
    ]
  }

  // {
  //   path: '/projects/:id/evaluation',
  //   component: EmptyRouterView,
  //   meta: {
  //     auth: true,
  //     layout: EvaluationLayout,
  //     pageTitle: 'ประเมินผลโครงการ',
  //     bodyClass: 'app-page',
  //     title: 'ประเมินผลโครงการ'
  //   },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'projects.show.evaluation.index',
  //       component: () => import(/* webpackChunkName: "project_evaluation_index" */ '../views/project/show/evaluation/Index.vue'),
  //       meta: {
  //         layout: EvaluationLayout,
  //         pageTitle: 'ประเมินผลโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'participants',
  //       name: 'projects.show.evaluation.participant',
  //       component: () => import(/* webpackChunkName: "project_evaluation_participant" */ '../views/project/show/evaluation/Participant.vue'),
  //       meta: {
  //         layout: EvaluationLayout,
  //         pageTitle: 'ประเมินผลโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'participantList',
  //       name: 'projects.show.evaluation.participantList',
  //       component: () => import(/* webpackChunkName: "project_evaluation_participant" */ '../views/project/show/evaluation/ParticipantList.vue'),
  //       meta: {
  //         layout: EvaluationLayout,
  //         pageTitle: 'ประเมินผลโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'expenses',
  //       name: 'projects.show.evaluation.expense',
  //       component: () => import(/* webpackChunkName: "project_evaluation_expenses" */ '../views/project/show/evaluation/Expense.vue'),
  //       meta: {
  //         layout: EvaluationLayout,
  //         pageTitle: 'ประเมินผลโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'gallery',
  //       name: 'projects.show.evaluation.gallery',
  //       component: () => import(/* webpackChunkName: "project_evaluation_gallery" */ '../views/project/show/evaluation/Gallery.vue'),
  //       meta: {
  //         layout: EvaluationLayout,
  //         pageTitle: 'ประเมินผลโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/projects/:id/proposal',
  //   name: 'projects.show.proposal.basic',
  //   component: () => import(/* webpackChunkName: "project_proposal_summary" */ '../views/project/show/proposal/Summary.vue'),
  //   meta: {
  //     auth: true,
  //     layout: ProjectShowLayout,
  //     pageTitle: 'รายละเอียดโครงการ',
  //     bodyClass: 'app-page'
  //   }
  // },
  // {
  //   path: '/projects/:id/event',
  //   component: EmptyRouterView,
  //   meta: {
  //     auth: true,
  //     layout: EventShowLayout,
  //     pageTitle: 'รายละเอียดโครงการ',
  //     bodyClass: 'app-page'
  //   },
  //   children: [
  //     {
  //       path: '/',
  //       name: 'projects.show.event.index',
  //       component: () => import(/* webpackChunkName: "project_event_summary" */ '../views/project/show/event/Summary.vue'),
  //       meta: {
  //         layout: EventShowLayout,
  //         pageTitle: 'รายละเอียดโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'attendee',
  //       name: 'projects.show.event.attendee',
  //       component: () => import(/* webpackChunkName: "project_event_attendee" */ '../views/project/show/event/Attendee.vue'),
  //       meta: {
  //         layout: EventShowLayout,
  //         pageTitle: 'รายละเอียดโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'registration',
  //       name: 'projects.show.event.registration',
  //       component: () => import(/* webpackChunkName: "project_event_registration" */ '../views/project/show/event/Registration.vue'),
  //       meta: {
  //         layout: EventShowLayout,
  //         pageTitle: 'รายละเอียดโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'survey',
  //       name: 'projects.show.event.survey',
  //       component: () => import(/* webpackChunkName: "project_event_survey" */ '../views/project/show/event/Survey.vue'),
  //       meta: {
  //         layout: EventShowLayout,
  //         pageTitle: 'รายละเอียดโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     },
  //     {
  //       path: 'staff',
  //       name: 'projects.show.event.staff',
  //       component: () => import(/* webpackChunkName: "project_event_staff" */ '../views/project/show/event/Staff.vue'),
  //       meta: {
  //         layout: EventShowLayout,
  //         pageTitle: 'รายละเอียดโครงการ',
  //         bodyClass: 'app-page'
  //       }
  //     }
  //   ]
  // }
  // {
  //   path: '/projects/:id/download',
  //   name: 'projects.show.download',
  //   component: () => import(/* webpackChunkName: "project_download" */ '../views/project/Download.vue'),
  //   meta: {
  //     layout: ProposalShowLayout,
  //     pageTitle: 'รายละเอียดโครงการ',
  //     bodyClass: 'app-page'
  //   }
  // }
]
